import request from './index'

// 根据地图包查询下属地图、轨迹信息
export const fileList= (flag,carId,mapPackNum)=>{
    return request({
        url: '/file/fileList',
        method: 'post',
        data: {
          command_id: 51,
          flag:flag,
          carId:carId,
          mapPackNum:mapPackNum
        }
    })
}

// 查询用户下地图包信息
export const listMapPack = (carId)=>{
    return request({
        url: '/file/listMapPack',
        method: 'post',
        data: {
            command_id: 51,
            carId: carId
        }
    })
}


export const filePreview = (flag,carId,fileName) =>{
    return request({
        url: '/file/filePreview',
        method: 'post',
        responseType: 'blob',
        data: {
            command_id:52,
            flag:flag,
            carId:carId,
            fileName:fileName
        }
    })
}

export const localDown= (flag,carId,mapPackNum,fileName)=>{
    return request({
        url: '/file/localDownload',
        method: 'post',
        data: {
          command_id: 53,
          flag:flag,
          carId:carId,
          mapPackNum:mapPackNum,
          fileName:fileName
        },
        responseType: 'blob'
    })
}

export const localDelete= (flag,carId,mapPackNum,fileName)=>{
    return request({
        url: '/file/localDelete',
        method: 'delete',
        data: {
          command_id: 36,
          flag:flag,
          carId:carId,
          mapPackNum:mapPackNum,
          fileName:fileName
        },
    })
}

//增加轨迹记录
export const addTraj = editHdmapTraj => {
  return request({
		url:'/file/insertTraj',
		method:'post',
		data:{
		  flag:'1',
		  carId: editHdmapTraj.carid,
		  mapId: editHdmapTraj.mapid,
		  trajName: editHdmapTraj.trajname,
		  trajId:editHdmapTraj.trajid,
		  trajUser:editHdmapTraj.trajuser
		}
	})
}

// 查询地图包轨迹信息
export const listTrajByCarMap = (carId,mapPackNum)=>{
    return request({
        url: '/file/listTrajByMap',
        method: 'post',
        data: {
            command_id: 51,
            carId: carId,
			mapPackNum:mapPackNum
        }
    })
}


export const deleteMapOrTraj = (id,netpic)=>{
    return request({
        url: '/file/deleteMapOrTrajById',
        method: 'post',
        data: {
			mapId:id,
			mapPackNum:netpic
        }
    })
}

export const deleteWork = (id)=>{
    return request({
        url: '/file/deleteWorkById',
        method: 'post',
        data: {
			mapId:id
        }
    })
}

export const deleteMapFolder = (carid,mapPackNum)=>{
    return request({
        url: '/file/deleteMapFolder',
        method: 'post',
        data: {
			carId:carid,
			mapPackNum:mapPackNum
        }
    })
}
